<template>
    <div :class="{ 'overlay': isLoading }">
        <div class="add_asset">
            <div class="d-flex align-items-center justify-content-between mb-3">
                <h5 style="font-weight: 700; margin: 0;">Sửa thông tin tài sản</h5>
            </div>
            <b-form class="form-add" @submit="updateAsset">
                <b-row>
                    <b-col cols="lg-7">
                        <h5>Thông tin chi tiết tài sản</h5>
                        <b-row style="align-items: center;">
                            <b-col cols="lg-4">
                                <label for="asset_name">Tên tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="asset_name" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập tên, mô tả tài sản" v-model="dataUpdate.asset_name"
                                    @input="formatTxt('asset_name')" required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="price">Giá khởi điểm:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="price" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập số tiền"
                                    v-model="dataUpdate.price" maxlength="15" @input="formatInput('price')" required>
                            </b-col>

                            <!-- <b-col cols="lg-4">
                                <p>Mã tài sản đấu giá:</p>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <p style="color: #444444; font-weight: 500; margin-bottom: 0;">MTS-HQ6EV3</p>
                            </b-col> -->

                            <b-col cols="lg-4">
                                <label for="time_start_regis">Thời gian bắt đầu đăng ký tham gia đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_start_regis" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_start_time_res"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_start_time_res"></b-form-timepicker> -->
                                        <b-form-input v-model="time_start_time_res" type="time" locale="vi"
                                            required></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_end_regis">Thời gian kết thúc đăng ký:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_end_regis" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_end_time_res"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_end_time_res"></b-form-timepicker> -->
                                        <b-form-input v-model="time_end_time_res" type="time" locale="vi"
                                            required></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="price_hs">Tiền mua hồ sơ:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="price_hs" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập số tiền"
                                    v-model="dataUpdate.record_fee" maxlength="15" @input="formatInput('record_fee')"
                                    required>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="step">Bước giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="step" class="mb-2 mr-sm-2 mb-sm-0 form-control" placeholder="Nhập bước giá"
                                    v-model="dataUpdate.step_price" maxlength="15" @input="formatInput('step_price')"
                                    required>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="max_step">Số bước giá trả tối đa / lần:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="max_step" class="mb-2 mr-sm-2 mb-sm-0 form-control"
                                    placeholder="Nhập số lần bước giá" v-model="dataUpdate.step" maxlength="5"
                                    @input="formatInput('step')" required>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="deposit">Tiền đặt trước:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <input id="deposit" class="mb-2 mr-sm-2 mb-sm-0 form-control"
                                    placeholder="Nhập số tiền đặt trước cho tài sản" v-model="dataUpdate.down_payment"
                                    maxlength="15" @input="formatInput('down_payment')" required>
                            </b-col>
                            <b-col cols="lg-4">
                            
                            </b-col>
                            <b-col cols="lg-8">
                            
                            <div class="custom-control custom-control-inline custom-checkbox" style="font-size: 20px;font-weight: 500;line-height: 36px;"> 
                                <input type="checkbox" style="width: 20px;height: 20px;" class="custom-control-input" v-model="isShowcntc">  Chủ tài sản là Tổ chức
                            </div>
                            </b-col>
                            <b-col cols="lg-4">
                                <label for="owner_name">Tên chủ tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="owner_name" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập tên chủ tài sản" v-model="dataUpdate.owner"
                                    @input="formatTxt('owner')" required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="owner_address">Địa chỉ chủ tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="owner_address" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập địa chỉ chủ tài sản" v-model="dataUpdate.owner_address" @input="formatTxt('owner_address')"
                                    required></b-form-input>
                            </b-col>

                            <div  v-if="isShowcntc"> 
                                <b-row style="align-items: center;">
                                <b-col cols="lg-4">
                                    <label for="rep_owner">Người đại diện chủ tài sản:</label>
                                </b-col>
                                <b-col cols="lg-8" class="input-form">
                                    <b-form-input id="rep_owner" class="mb-2 mr-sm-2 mb-sm-0"
                                        placeholder="Nhập người đại diện chủ tài sản"  v-model="dataUpdate.rep_owner"   @input="formatTxt('rep_owner')"
                                         ></b-form-input>
                                </b-col>

                                <b-col cols="lg-4">
                                    <label for="owner_position">Chức vụ người đại diện:</label>
                                </b-col>
                                <b-col cols="lg-8" class="input-form">
                                    <b-form-input id="owner_position" class="mb-2 mr-sm-2 mb-sm-0"
                                        placeholder="Nhập chức vụ người đại diện" v-model="dataUpdate.owner_position"  @input="formatTxt('owner_position')"
                                        ></b-form-input>
                                </b-col>
                                </b-row>
                            </div>

                            

                            <b-col cols="lg-4">
                                <label for="address">Nơi xem tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="address" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập địa chỉ, nơi xem tài sản" v-model="dataUpdate.view_address"
                                    @input="formatTxt('view_address')" required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_start">Thời gian bắt đầu trả giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_start" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_start_time"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_start_time"></b-form-timepicker> -->
                                        <b-form-input v-model="time_start_time" type="time" locale="vi"
                                            required></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="time_end">Thời gian kết thúc trả giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-row>
                                    <b-col cols="lg-6">
                                        <div>
                                            <b-form-datepicker id="time_end" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="date_end_time"></b-form-datepicker>
                                        </div>
                                    </b-col>
                                    <b-col cols="lg-6">
                                        <!-- <b-form-timepicker locale="vi" placeholder="Chọn thời gian" v-model="time_end_time"></b-form-timepicker> -->
                                        <b-form-input v-model="time_end_time" type="time" locale="vi"
                                            required></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="cate">Danh mục tài sản:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-select id="cate" class="form-control form-select" v-model="dataUpdate.category_id"
                                    required>
                                    <b-form-select-option :value="null">Chọn danh mục</b-form-select-option>
                                    <b-form-select-option v-for="item in listCate" :key="item.category_id"
                                        :value="item.category_id">{{ item.name }}</b-form-select-option>
                                </b-form-select>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="branch">Chi nhánh tổ chức đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-select id="branch" class="form-control form-select" v-model="dataUpdate.agency_id"
                                    required>
                                    <b-form-select-option :value="null">Chọn chi nhánh tổ chức đấu
                                        giá</b-form-select-option>
                                    <b-form-select-option v-for="item in listAgency" :key="item.agency_id"
                                        :value="item.agency_id">{{ item.agency_name }}</b-form-select-option>
                                </b-form-select>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contractually">Số hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="contractually" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số hợp đồng đấu giá" v-model="dataUpdate.contractually" @input="formatTxt('contractually')"
                                    required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contractually_date">Ngày ký hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-datepicker id="contractually_date" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="dataUpdate.contractually_date"></b-form-datepicker>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contract_annexes">Phụ lục hợp đồng đấu giá:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="contract_annexes" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số hợp đồng đấu giá" v-model="dataUpdate.contract_annexes" @input="formatTxt('contract_annexes')"
                                    required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="contract_annexes_date">Ngày ký phụ lục hợp đồng:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-datepicker id="contract_annexes_date" start-weekday=1 placeholder="Chọn ngày"
                                                locale="vi" v-model="dataUpdate.contract_annexes_date"></b-form-datepicker>
                            </b-col>
                        </b-row>

                        <h5 style="font-size: 20px; font-weight: 600;">THÔNG BÁO ĐẤU GIÁ</h5>
                        <ckeditor :editor="editor" v-model="dataUpdate.auction_noti" :config="editorConfig"
                            @ready="onReady"></ckeditor>
                    </b-col>
                    <b-col cols="lg-5">
                        <h5>Hình ảnh tài sản:</h5>
                        <!-- <b-row v-if="image && image.length !== 0">
                            <b-col cols="lg-3" class="mb-3" v-for="(data, index) in image" :key="index">
                                <img :src="data.previewUrl" alt="" style="border-radius: 11px; width: 137px; height: 103px; object-fit: cover;">
                            </b-col>
                        </b-row>                        
                        <input type="file" id="file-upload" accept="image/png, image/gif, image/jpeg, image/jpg" multiple @change="handleImgChangeMuty">
                            <img src="@/assets/admin/icon/icon_add.png" style="width: 20%;" onclick="$('#file-upload').click()">
                            <div class="image-container">
                                <div v-for="(ima, index) in image" :key="ima.file_id" class="image-item">
                                    <img :src="ima.previewUrl" alt="Preview" class="profile-pic" @click="showImage(index)">
                                    <button class="remove-button" @click="removeImage(ima.file_id,index)">X</button>
                                </div>
                            </div>
                            <div v-if="showModal" class="modal" @click.self=" closeModal">
                            <div class="modal-content">
                                <span class="close" @click="closeModal">&times;</span>
                                <img :src="selectedImage.previewUrl" alt="Preview" class="modal-image">
                            </div>
                            </div> -->
                            <b-row v-if="images && images.length !== 0">
                            <b-col cols="lg-3" class="mb-3" v-for="(data, index) in images" :key="index">
                                <img :src="data.previewUrl"  alt="" style="border-radius: 11px; width: 137px; height: 103px; object-fit: cover;">
                            </b-col>
                        </b-row>                        
                        <b-form-file  type="file" id="file-upload" accept="image/png, image/gif, image/jpeg, image/jpg" multiple @change="handleImgChangeMuty" ref="fileInput"></b-form-file>
                            <img src="@/assets/admin/icon/icon_add.png" style="width: 20%;" onclick="$('#file-upload').click()">
                            <div class="image-container">
                                <div v-for="(image, index) in images" :key="image.id" class="image-item">
                                    <img :src="image.previewUrl" alt="Preview" class="profile-pic" @click="showImage(index)">
                                    <button class="remove-button" @click.prevent.stop="removeImage(image.id,index)">X</button>
                                </div>
                            </div>
                            <div v-if="showModal" class="modal" @click.self=" closeModal">
                            <div class="modal-content">
                                <span class="close" @click="closeModal">&times;</span>
                                <img :src="selectedImage.previewUrl" alt="Preview" class="modal-image">
                            </div>
                            </div>
                        <h5>Thông tin tổ chức đấu giá </h5>
                        <b-row>
                            <b-col cols="lg-4">
                                <label for="unit"><img src="@/assets/icon/Company.png" alt=""
                                        style="padding-right: 14px;">Đơn vị tổ chức:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="unit" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Nhập đơn vị tổ chức đấu giá" v-model="dataUpdate.org"
                                    @input="formatTxt('org')" required></b-form-input>
                            </b-col>

                            <b-col cols="lg-4">
                                <label><img src="@/assets/icon/Customer.png" alt="" style="padding-right: 14px;">Đấu giá
                                    viên:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-dropdown :text="text_dgv" class="button-list">
                                    <b-dropdown-item v-for="(dgv, index) in listDGV" :key="index"
                                        @click="getNameDGV(dgv.full_name, dgv.user_id)">
                                        <div class="d-flex align-items-center">
                                            <img :src="$storage + dgv.avatar" alt=""
                                                style="width: 45px; height: 45px; border-radius: 31px;"
                                                @error="handleError">
                                            <div class="ml-3">
                                                <p style="font-weight: 500; margin-bottom: 0;">{{ dgv.full_name }}</p>
                                                <p class="m-0">Đấu giá viên - {{ dgv.agency_name }}</p>
                                            </div>
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </b-col>

                            <b-col cols="lg-4">
                                <label for="add"><img src="@/assets/icon/Location.png" alt=""
                                        style="padding-right: 14px;">Địa điểm:</label>
                            </b-col>
                            <b-col cols="lg-8" class="input-form">
                                <b-form-input id="add" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Địa điểm tổ chức, trụ sở công ty" v-model="dataUpdate.address"
                                    @input="formatTxt('address')" required></b-form-input>
                            </b-col>
                        </b-row>

                        <h5>Tài liệu liên quan</h5>
                        <b-row>
                            <b-col>
                                <input class="custom-file-input mb-2" type="file" @change="handleFileChange($event, 'file')" accept="application/pdf">
                                
                                <div  class="mb-2" v-for="(item, index) in dataUpdate.file" :key="'old-' + index">
                                <img src="@/assets/icon/Note.png">
                                {{ item.file_name }}
                                <span class="btn btn-danger btn-sm ml-1" @click="removeOldFile(item, index)">
                                        Xóa
                                    </span>
                                </div> 
                                <div v-for="(item, index) in newFiles.filter(f => f.type === 'file')" :key="index" class="mb-2 d-flex align-items-center">
                                        <img src="@/assets/icon/Note.png">
                                        <span class="ml-2">
                                            {{ item.file.name }}
                                        </span>
                                        <span class="btn btn-danger btn-sm ml-1" @click="removeNewFile(index)">
                                        Xóa
                                    </span>
                                    </div>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Quy chế đấu giá</h5>
                        <b-row>
                            <b-col>
                                <input class="custom-file-input mb-2" type="file" accept="application/pdf" @change="handleFile2Change($event, 'file2')">
                                <!-- Có file mới thì hiển thị file mới -->
                                <div v-if="newFileQC" class="mb-2">
                                    <img src="@/assets/icon/Note.png">
                                    {{ newFileQC.name }} 
                                </div> 
                                <!-- Không có file mới thì hiển thị file cũ -->
                                <div class="mb-2" v-else-if="fileQCDT">
                                    <img src="@/assets/icon/Note.png" alt="">
                                    {{ fileQCDT.file_name }}
                                </div>                             
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Số quy chế đấu giá</h5>
                        <b-row>
                            <b-col>
                                <b-form-input id="add" class="mb-2 mr-sm-2 mb-sm-0"
                                    placeholder="Số quy chế đấu giá" v-model="dataUpdate.statute"
                                    @input="formatTxt('statute')" required></b-form-input>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Ngày cấp quy chế đấu giá</h5>
                        <b-row>
                            <b-col>
                                <b-form-datepicker start-weekday=1 placeholder="Chọn ngày"
                                            locale="vi" v-model="dataUpdate.statute_date"></b-form-datepicker>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 28px;">Quy chế riêng</h5>
                        <b-row>
                            <b-col>
                                <b-form-textarea placeholder="Nhập quy chế riêng cho tài sản" rows="5" max-rows="8"
                                    v-model="dataUpdate.own_regulation" @input="formatTxt('own_regulation')"
                                    required></b-form-textarea>
                            </b-col>
                        </b-row>

                        <h5 style="margin-top: 18px;">Hồ sơ yêu cầu đăng ký tham gia</h5>
                        <div class="btn-bg" :class="{ 'set-height': dataList.length !== 0 }">
                            <p v-if="dataList !== ''" v-for="(data, index) in dataList" :key="index" class="pl-3">{{ data }}
                            </p>
                            <p v-if="dataList == ''" v-for="(data, index) in required_name" :key="index" class="pl-3">{{
                                data }}</p>
                            <button class="btn-add-req" @click="$refs.listFile.show()" type="button">Chỉnh sửa yêu
                                cầu</button>
                        </div>

                        <div>
                            <button class="add_asset_btn" type="button" @click="$router.go(-1)" :disabled="isLoading">Hủy
                                bỏ</button>
                            <button class="add_asset_btn add_asset_btn--red" type="submit" :disabled="isLoading">Lưu chỉnh
                                sửa</button>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <listFile ref="listFile" @sendDataList="getDataList" />
        </div>
        <div class="loader" v-if="isLoading"></div>
    </div>
</template>
<script>
import listFile from "./modal/list_file.vue";
import Editor from '@ckeditor/ckeditor5-build-decoupled-document';
//import '@ckeditor/ckeditor5-build-classic/build/translations/vi';
import axios from 'axios'
export default {
    components: { listFile },
    data() {
        function uploader(editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return uploadImages(loader);
            };
        }

        // function uploadImage(loader) {
        //     return {
        //         upload: () => {
        //             return new Promise((resolve, reject) => {
        //                 loader.file.then(async (file) => {
        //                     try {
        //                         if (!file) return

        //                         var data = {
        //                             'file': file,
        //                             'path': 'asset/image/'
        //                         }

        //                         await axios.post('https://api.daugiadgv.vn/api/common/uploadFile', data, {
        //                             headers: {
        //                                 'x-access-token': '',
        //                                 'Content-Type': 'multipart/form-data'
        //                             }
        //                         }).then(res => {
        //                             const url = 'https://api.daugiadgv.vn/storage/' + res.data.list_result[0].path_tam
        //                             resolve({ default: url })
        //                         })
        //                     } catch (error) {
        //                         reject(error)
        //                     }
        //                 })
        //             })
        //         }
        //     }
        // }
        return {
            text_dgv: 'Tên đấu giá viên',
            date_start_time_res: '',
            time_start_time_res: '',
            date_end_time_res: '',
            time_end_time_res: '',
            date_start_time: '',
            time_start_time: '',
            date_end_time: '',
            time_end_time: '',
            dataImg: [],
            images: [],          // ảnh đang hiển thị (cũ + mới)
            removedImages: [],   // ảnh cũ bị xóa
            showModal: false,
            selectedImage: null,            
            // dataFile: [],
            // dataFile2: [],
            //datafiles: [],     // file mới chọn
            //fileMain: [],     // file cũ từ DB (file)
            //fileSub: null,    // file cũ từ DB (file2) 
            fileDT: null, // file data db           
            fileQCDT: null, // file2 data db
            newFileQC: null, // file2 QC mới vừa upload
            newFiles: [],       // file mới vừa upload
            removedFiles: [],   // Xóa file mới vừa upload
            dataList: [],
            token: '',
            listAgency: [],
            listCate: [],
            listDGV: [],
            dataUpdate: {
                asset_name: '',
                price: '',
                register_start_time: '',
                register_end_time: '',
                record_fee: '',
                step_price: '',
                step: '',
                down_payment: '',
                owner: '',
                view_address: '',
                start_time: '',
                end_time: '',
                category_id: null,
                agency_id: null,
                auction_noti: '',
                images: [], // ảnh cũ từ DB
                removedImages: [],   // ảnh cũ bị xóa
                listimages: [],  //anh mới
                org: '',
                dgv: '',
                address: '',
                regulation: '',
                own_regulation: '',
                file: [],
                file2: [],
                required_file: [],
                publish_status: '',
                contractually: '',
                contractually_date: null,
                contract_annexes: '',
                contract_annexes_date: '',
                statute: '',
                statute_date: null,
                owner_address: '',
                rep_owner: '',
                owner_position: '',
            },
            number: 0,
            id: '',
            file_update: [],
            required_name: [],
            isLoading: false,
            isShowcntc: false,
            isInit: true, //load dau tien
            editor: Editor,
            editorConfig: {
                extraPlugins: [uploader],
                language: 'vi',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'strikethrough',
                        'underline',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        '|',
                        'imageUpload',
                        'link',
                        '|',
                        'blockQuote',
                        'insertTable',
                        'alignment',
                        '|',
                        'fontFamily',
                        'fontSize',
                        'fontColor',
                        'fontBackgroundColor',
                    ]
                },
            }
        }
    },
    
    mounted() {
        const storedData = localStorage.getItem('admInfo')
        if (storedData) {
            var info = JSON.parse(storedData)
            this.token = info.accessToken
        }
        this.id = this.decode(this.$route.params.asset_id)
        this.getListAgency()
        this.getListCate()
        this.getListDGV()
        this.getDetailAsset()
        
        if (
            this.dataUpdate.rep_owner ||
            this.dataUpdate.owner_position
        ) {
            this.isShowcntc = true
        } else {
            this.isShowcntc = false
        }
    },
    watch: {
        dataUpdate: {
            handler(val) {
            if (val.rep_owner || val.owner_position) {
                this.isShowcntc = true
            } else {
                this.isShowcntc = false
            }
            this.isInit = false
            },
            deep: true,
            immediate: true
        },
        isShowcntc(val) {
            // CHỈ clear khi user bỏ tick
            if (!val && !this.isInit) {
            this.dataUpdate.rep_owner = null
            this.dataUpdate.owner_position = null
            }
        }
    },
    methods: {
        //start images upload
        handleImgChangeMuty(event) {
            if (!event?.target?.files) return;
            const files = Array.from(event.target.files);
            const MAX_SIZE = 3 * 1024 * 1024; // 3MB
            if (!files.length) return;
            const vm = this; // giữ Vue instance
            files.forEach(file => {
                if (file) {
                    if (file.size > MAX_SIZE) {
                        //alert(`Ảnh "${file.name}" không vượt quá dung lượng 2MB`);
                        this.$toast.error('file ' + file.name + ' không vượt quá dung lượng 3MB!')
                        event.target.value = '';
                        return;
                    }
                    if (!file.type.startsWith('image/')) {
                        alert(`"${file.name}" không phải là ảnh`);return;
                    }
                    const dotIndex = file.name.lastIndexOf('.'); //Tách tên & extension
                    const name = file.name.substring(0, dotIndex);
                    const ext = file.name.substring(dotIndex);
                    let cleanName = name.replace(/^\d+[-_]*/, ''); //Bỏ số ở đầu + dấu -
                    cleanName = cleanName.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').replace(/Đ/g, 'D').replace(/\s+/g, '-');; // bỏ tiếng việt có dấu
                    const now = new Date();
                    const time = now.getFullYear() +('0' + (now.getMonth() + 1)).slice(-2) +('0' + now.getDate()).slice(-2) +'-' +('0' + now.getHours()).slice(-2) +('0' + now.getMinutes()).slice(-2) +('0' + now.getSeconds()).slice(-2);                    
                    const newFileName = `${cleanName}-${time}${ext}`;// tạo file mới
                    const newFileimage = new File([file], newFileName, {type: file.type});
                    // preview
                    const reader = new FileReader();
                    reader.onload = e => {
                        vm.images.push({
                            file: newFileimage,
                            previewUrl: e.target.result,
                            isOld: false
                        });
                        // vm.images.push({
                        //     id: null,
                        //     file: newFileimage,
                        //     previewUrl: e.target.result,
                        //     isOld: false
                        // });
                        
                    }; 

                    reader.readAsDataURL(newFileimage);   
                }               
            });    
        },
        async uploadImages() {        //api      
        //    if (!this.images.length) {
        //         //alert('Vui lòng chọn ít nhất 1 ảnh');
        //         this.$toast.error('Vui lòng chọn ít nhất 1 ảnh')
        //         return;
        //     }
            const formData = new FormData();
            //dữ liệu text
            formData.append('asset_name', this.assetName);
            formData.append('description', this.description);            
            // ảnh mới
            this.images.forEach(img => {
                if (!img.isOld && img.file) {
                formData.append('images', img.file);
                }
            });
            // ảnh bị xóa
            formData.append(
                'removedImages',JSON.stringify(this.removedImages)
            );
            
            //2. gửi id ảnh cũ bị xóa
            // this.removedImages.forEach(id => {
            //     form.append('removedImages[]', id);
            // });           
            try {
                const res = await this.$axios.post(
                '/common/uploadFileimages',
                formData,
                {
                    headers: {
                    'x-access-token': this.token,
                    'Content-Type': 'multipart/form-data'
                    }
                }
                );
                //console.log('Upload OK:', res.data.list_result);
                // GHI VÀO dataAdd
                this.dataUpdate.listimages = res.data.list_result;
                //RETURN CHO addAsset
                return res.data.list_result;

            } catch (err) {
                console.error(err);
                return [];
            }
            
        },        
        
        removeImage(id,index) {    
            //alert(id);        
            const img = this.images[index];           
            if (img.isOld && id) {
                this.removedImages.push(id);
            }
            this.images.splice(index, 1);
            // dọn rác nếu Vue từng render lỗi
            this.images = this.images.filter(i => i && i.previewUrl);
        },    
        showImage(index) {
            this.selectedImage = this.images[index];
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.selectedImage = null;
        },
        //end images upload
        handleFileChange(event, fileType) {
            const input = event.target;
            const files = Array.from(input.files || []);
            //if (files.length === 0) return;
            const MAX_SIZE = 1 * 1024 * 1024; // 10MB
            // Duyệt tất cả file được chọn
            files.forEach(file => {
                // Kiểm tra dung lượng
                if (file.size > MAX_SIZE) {
                    this.$toast.error(
                        'File "' + file.name + '" không được vượt quá 10MB!'
                    );
                    return;
                }
                // Kiểm tra file đã tồn tại chưa
                const isExist = this.newFiles.some(
                    item =>
                        item.type === fileType &&
                        item.file.name === file.name &&
                        item.file.size === file.size
                );
                if (isExist) {
                    this.$toast.warning(
                        'File "' + file.name + '" đã được chọn!'
                    );
                    return;
                }
                // Đổi tên file
                const renamedFile = this.renameFile(file);
                if (!renamedFile) {
                    return;
                }
                // Thêm vào danh sách
                this.newFiles.push({
                    file: renamedFile,
                    type: fileType,
                    title: renamedFile.name
                });
                //this.uploadFile(type, renamedFile);
            });            
            input.value = ''; 
        },
        handleFile2Change(event, type) {
            const input = event.target;
            const file = input.files?.[0];
            if (!file) return;
            const MAX_SIZE = 10 * 1024 * 1024; // 1MB
            // Kiểm tra dung lượng
            if (file.size > MAX_SIZE) {
                this.$toast.error(
                    'File "' + file.name + '" không được vượt quá 10MB!'
                );
                input.value = '';
                return;
            }
            // Lưu file mới
            if (type === 'file2') {
                const renamedFile = this.renameFile(file);
                if (!renamedFile) {
                    input.value = '';
                    return;
                }
                this.newFileQC = renamedFile;
            }
            input.value = '';
        },
        renameFile(file) {
            const dotIndex = file.name.lastIndexOf('.');
            const name = file.name.substring(0, dotIndex);
            const ext = file.name.substring(dotIndex);
            //let cleanName = name.replace(/^\d+[-_]*/, '');
            let cleanName = name.replace(/^[\d._-]+/, '');
            cleanName = cleanName
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd')
                .replace(/Đ/g, 'D')
                .replace(/\s+/g, '-');
            const now = new Date();
            const time =
                now.getFullYear() +
                ('0' + (now.getMonth() + 1)).slice(-2) +
                ('0' + now.getDate()).slice(-2) + '-' +
                ('0' + now.getHours()).slice(-2) +
                ('0' + now.getMinutes()).slice(-2) +
                ('0' + now.getSeconds()).slice(-2);
            const newFileName = `${cleanName}-${time}${ext}`;
            return new File([file], newFileName, { type: file.type });
        }, 
        removeOldFile(item, index) {
            //console.log("FILE CŨ:", item);
           // console.log("FILE ID:", item.file_id);
            //if (this.removedFiles && this.removedFiles.length > 0) {
                if (item.file_id && !this.removedFiles.includes(item.file_id)) {
                    this.removedFiles.push(item.file_id);
                }
           // }
            // Chỉ xóa khỏi giao diện
            // Chưa xóa DB
            this.dataUpdate.file.splice(index, 1);
            //console.log("removedFiles:", this.removedFiles);
        }, 
        removeNewFile(index) {
            this.newFiles.splice(index, 1);
        },    
        // async uploadFile(type, file) {   
            
        //     const form = new FormData();
        //    // if (Array.isArray(this.newFiles)) {
        //         this.newFiles.forEach(item => {
        //             //form.append(f.type, f.file); // file | file2
        //             if (!item || !item.file) {
        //                 return;
        //             }

        //             if (item.type === 'file') {
        //                 form.append(
        //                     'files',
        //                     item.file,
        //                     item.file.name
        //                 );
        //             }               
        //         });
        //    // }  
           
        //    if (this.newFileQC) {
        //         form.append(
        //             'files',
        //             this.newFileQC,
        //             this.newFileQC.name
        //         );
        //     }
        //     // ID file DB cần xóa
        //     this.removedFiles.forEach(id => {
        //         form.append("removedFiles", String(id));
        //     });
        //     //console.log("removedFilesvvvv:", this.removedFiles);

        //     //debug
        //     for (const [key, value] of form.entries()) {
        //         console.log(
        //             'FORM:',
        //             key,
        //             value instanceof File
        //                 ? {
        //                     name: value.name,
        //                     size: value.size,
        //                     type: value.type
        //                 }
        //                 : value
        //         );

        //     }
        //     // Không có file mới và không có file cần xóa
        //     const hasNewFile =
        //         this.newFiles.some(x => x?.file) ||
        //         !!this.newFileQC;

        //     const hasRemovedFile =
        //         this.removedFiles.length > 0;

        //     if (!hasNewFile && !hasRemovedFile) {

        //         console.log('Không có thay đổi file');

        //         return [];

        //     }
        //     try {
        //         const res = await this.$axios.post('/common/uploadFileMunty',form,
        //         {
        //             headers: {
        //             'x-access-token': this.token
        //             }
        //         }
        //         ); 
        //         // console.log('UPLOAD RESULT:', res.data.list_result);               
        //         // return res.data.list_result || [];

        //         const fileCount = this.newFiles.filter(
        //             item => item?.file && item.type === 'file'
        //         ).length;

        //         const file = result.slice(0, fileCount);
        //         const file2 = result.slice(fileCount);

        //         return {
        //             file,
        //             file2
        //         };
        //     } catch (err) {
        //         console.error(err);
        //         return [];
        //     }
        //     return {
        //         file: [],
        //         file2: []
        //     };
            
        // }, 

        // async uploadFile2(type, file) {   
        //     // if (!this.fileQCDT) {
        //     //     console.log('Không có file2 mới → không upload');
        //     //     return [];
        //     // } 
        //     const form = new FormData();            
        //     if (this.newFileQC) {
        //         form.append(
        //             'file2',
        //             this.newFileQC,
        //             this.newFileQC.name
        //         );
        //     }
           
        //     try {
        //         const res = await this.$axios.post('/common/uploadFileMunty',form,
        //         {
        //             headers: {
        //             'x-access-token': this.token
        //             }
        //         }
        //         );              
        //         return res.data.list_result || [];
        //     } catch (err) {
        //         console.error(err);
        //         return [];
        //     }            
        // },
        async uploadFile() {
            const form = new FormData();    
            // TÀI LIỆU
            const fileList = this.newFiles.filter(item => item && item.file && item.type === 'file');
            fileList.forEach(item => {
                form.append('files', item.file,item.file.name);
            });
            // QUY CHẾ  
            if (this.newFileQC) {
                form.append('files', this.newFileQC,this.newFileQC.name);                
            }
            // PATH 
            form.append('path_moi','asset/file/');
            // DEBUG
            for (const [key, value] of form.entries()) {
                //console.log('FORM:',key,value instanceof File ? value.name: value);
            }    
            // KHÔNG CÓ FILE MỚI 
            if (fileList.length === 0 && !this.newFileQC) {
                return {
                    file: [], file2: []
                };
            }
            try {
                const res = await this.$axios.post('/common/uploadFileMunty',form,{
                        headers: {'x-access-token':this.token}
                    });
                const result = res.data?.list_result || [];
                //console.log('UPLOAD RESULT:',result);
                // TÁCH FILE
                const fileCount = fileList.length;
                const files = result.slice(0, fileCount);
                const file2 = result.slice(fileCount);
                return {
                    file: files,file2: file2
                };
            } catch (err) {
                console.error('UPLOAD ERROR:',
                    err.response?.data || err
                );
                return {
                    file: [], file2: []
                };
            }
        },		
        getDataList(data) {
            this.dataList = []
            this.dataUpdate.required_file = []
            data.forEach(element => {
                this.dataList.push(element.required_file_name)
                this.dataUpdate.required_file.push(element.id)
            });
        },
        formatInput(field) {
            if (this.dataUpdate[field]) {
                const cleanedValue = this.dataUpdate[field].replace(/[^\d]/g, '');
                this.number = parseInt(cleanedValue, 10);
                this.dataUpdate[field] = this.number.toLocaleString();
            }
        },
        
        async getListAgency() {
            const res = await this.$axios.get('/agency/getListAgency', {
                headers: {
                    'x-access-token': this.token
                }
            }).then(res => {
                this.listAgency = res.data
            }).catch(err => {
                if (err.response.status == 409) {
                    localStorage.removeItem('admInfo')
                    this.$toast.error('Tài khoản được đăng nhập từ thiết bị khác!')
                    this.$router.push('/loginAdmin')
                } else if (err.response.status == 401) {
                    localStorage.removeItem('admInfo')
                    this.$toast.error('Phiên đăng nhập đã hết hạn!')
                    this.$router.push('/loginAdmin')
                }
            })
        },
        async getListCate() {
            const res = await this.$axios.get('/category/getListCategory', {
                params: {
                    code: '',
                    name: '',
                    status: '',
                    parent_id: '',
                    page: '1',
                    per_page: '10000',
                },
                headers: {
                    'x-access-token': this.token
                }
            })
            if (res.status == 200) {
                this.listCate = res.data.result
            }
        },
        async getListDGV() {
            const res = await this.$axios.get('/auth/getListUser', {
                params: {
                    user_name: '',
                    user_code: '',
                    role_id: '3',
                    agency_id: '',
                    phone: '',
                    address: '',
                    email: '',
                    full_name: '',
                    gender: '',
                    birthday: '',
                    soTheDGV: '',
                    cccd: '',
                    page: '1',
                    per_page: '10000',
                },
                headers: {
                    'x-access-token': this.token
                }
            })
            if (res.status == 200) {
                this.listDGV = res.data.result
            }
        },
        getNameDGV(name, id) {
            this.text_dgv = name
            this.dataUpdate.dgv = id
        },
        async updateAsset() {
            event.preventDefault()
            if (this.date_start_time_res !== '' && this.time_start_time_res !== '') {
                this.dataUpdate.register_start_time = this.date_start_time_res + " " + this.time_start_time_res
            }
            if (this.date_end_time_res !== '' && this.time_end_time_res !== '') {
                this.dataUpdate.register_end_time = this.date_end_time_res + " " + this.time_end_time_res
            }
            if (this.date_start_time !== '' && this.time_start_time !== '') {
                this.dataUpdate.start_time = this.date_start_time + " " + this.time_start_time
            }
            if (this.date_end_time !== '' && this.time_end_time !== '') {
                this.dataUpdate.end_time = this.date_end_time + " " + this.time_end_time
            }
            this.dataUpdate.price = this.dataUpdate.price.replace(/[^\d]/g, '')
            this.dataUpdate.record_fee = this.dataUpdate.record_fee.replace(/[^\d]/g, '')
            this.dataUpdate.step_price = this.dataUpdate.step_price.replace(/[^\d]/g, '')
            this.dataUpdate.down_payment = this.dataUpdate.down_payment.replace(/[^\d]/g, '')

            this.dataUpdate.publish_status = "1"

            try { 
                 
                const images = await this.uploadImages();
                this.dataUpdate.listimages = images;
                this.dataUpdate.removedImages =  this.removedImages 
                if (this.removedFiles && this.removedFiles.length > 0) {
                this.dataUpdate.removedFiles = this.removedFiles;
                }    
                const files = await this.uploadFile();
                this.dataUpdate.newFiles = files;
                const files2 = await this.uploadFile2();
                this.dataUpdate.newFileQC = files2;
                //console.log('FILES UPLOADED:', dataUpdate.newFiles);
                //console.log("FILE DB CẦN XÓA:", removedFiles);
                //this.removedFiles = this.removedFiles
                //this.dataUpdate.newFileMain =  this.newFileMain 
                ///this.dataUpdate.newFileSub =  this.newFileSub
                
            } catch (e) {
                console.error(e);
            }
            if (!this.dataUpdate.register_start_time || !this.dataUpdate.register_end_time || !this.dataUpdate.start_time || !this.dataUpdate.end_time || this.dataUpdate.images.length == 0 || this.dataUpdate.required_file.length == 0 || !this.dataUpdate.dgv) {
                this.$toast.error('Vui lòng nhập đầy đủ thông tin!')
            } else {
                this.isLoading = true
                await this.$axios.put('/asset/updateAsset', this.dataUpdate, {
                    headers: {
                        'x-access-token': this.token,
                    }
                }).then(res => {
                    this.$toast.success('Sửa tài sản thành công!')
                    this.$router.go(-1)
                    this.isLoading = false
                }).catch(err => {
                    this.$toast.error('Sửa tài sản không thành công!')
                    this.isLoading = false
                })
            }
        },
        async getDetailAsset() {
            const res = await this.$axios.get('/asset/getAssetDetail', {
                params: {
                    asset_id: this.id,
                },
                headers: {
                    'x-access-token': this.token
                }
            })
            if (res.status == 200) {
                this.dataUpdate = res.data
                this.dataUpdate.address = res.data.auction_address
                this.date_start_time_res = this.$moment.utc(res.data.register_start_time).format("YYYY-MM-DD")
                this.time_start_time_res = this.$moment.utc(res.data.register_start_time).format("HH:mm:ss")
                this.date_end_time_res = this.$moment.utc(res.data.register_end_time).format("YYYY-MM-DD")
                this.time_end_time_res = this.$moment.utc(res.data.register_end_time).format("HH:mm:ss")
                this.date_start_time = this.$moment.utc(res.data.start_time).format("YYYY-MM-DD")
                this.time_start_time = this.$moment.utc(res.data.start_time).format("HH:mm:ss")
                this.date_end_time = this.$moment.utc(res.data.end_time).format("YYYY-MM-DD")
                this.time_end_time = this.$moment.utc(res.data.end_time).format("HH:mm:ss")
                this.text_dgv = res.data.DGV
                this.dataUpdate.dgv = res.data.dgv_id
                const dataRequired = []
                this.required_name = []
                res.data.required_file.forEach(element => {
                    dataRequired.push(element.required_file_id)
                    this.required_name.push(element.required_file_name)
                });
                this.dataUpdate.required_file = dataRequired
                const listimages = this.dataUpdate.images || [];                 
                this.images = listimages.map(path => ({
                    id: path,                          // dùng path làm id
                    file: null,
                    previewUrl: this.$storage + path,  // http://localhost:3000/storage/' + img.source,
                    isOld: true,
                    file_name: path.split('/').pop()   // lấy tên file
                }));
                //this.fileMain = res.data.file;
                this.fileDT = res.data.file;
                this.fileQCDT = res.data.file2[0]|| null;                
                //this.fileMain = res.data.file?.length ? res.data.file[0] : null
                //this.fileSub  = res.data.file2?.length ? res.data.file2[0] : null
                //this.newfileMain = res.data.file;
                //this.newfileSub  = res.data.file2;
                // console.log("dataupload:", res.data);
            }
        },
        onReady(editor) {
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formatTxt(item) {
            this.dataUpdate[item] = this.dataUpdate[item].replace(/[<>\[\]]/g, '')
        }
        
    }
}
</script>
<style lang="css" scoped>
.set-height {
    height: fit-content !important;
    padding-bottom: 20px;
}

.add_asset {
    color: #515151;
    font-family: Roboto;
}

.add_asset h5 {
    font-size: 20px;
    font-weight: 500;
    line-height: 36px;
}

.form-add {
    box-shadow: 2px 2px 6px 0px #00000026;
    background-color: #FFFFFF;
    border-radius: 15px;
    padding: 19px 10px 32px 30px;
}

.form-add .col-lg-8 {
    margin-bottom: 15px;
}

.form-add input.form-control,
.form-add .form-select,
.form-add textarea.form-control {
    background-color: #EEEEEE;
    border: none;
    border-radius: 15px;
    padding: 11px 12px;
}

.form-add textarea.form-control {
    overflow-y: auto !important;
}

.form-add input.form-control:focus,
.form-add .form-select:focus,
.form-add textarea.form-control {
    box-shadow: none;
}

.form-add input.form-control::placeholder {
    color: #B4B4B4;
}

.custom-file-input::-webkit-file-upload-button {
    visibility: hidden;
}

.custom-file-input {
    color: #515151;
    margin-left: 100px;
    background: #EEEEEE;
    border-radius: 15px;
    padding: 3px 0;
}

.custom-file-input::before {
    position: absolute;
    left: 10px;
    content: 'Chọn file';
    display: inline-block;
    background: #444444;
    border-radius: 15px;
    padding: 6px 13px;
    outline: none;
    white-space: nowrap;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
}

.add_asset button {
    background: none;
    border: none;
}

.add_asset .add_asset_btn {
    color: #EE3439;
    border: 1px solid #EE3439;
    border-radius: 15px;
    box-shadow: 2px 2px 6px 0px #00000026;
    width: 160px;
    height: 42px;
    border-radius: 20px;
    margin-right: 9px;
    margin-top: 20px;
}

.add_asset .add_asset_btn--red {
    color: #FFFFFF;
    background: #EE3439;
    width: 204px;
    height: 45px;
}

.btn-bg {
    background: #EEEEEE;
    border-radius: 15px;
    min-height: 105px;
    padding-top: 10px;
}

.btn-add-req {
    color: #EE3439;
    font-weight: 500;
    padding: 10px 0 10px 15px;
}

.draft {
    color: #EE3439;
    border: 1px solid #EE3439 !important;
    border-radius: 20px;
    font-weight: 500;
    padding: 4px 38px;
}

.button-list {
    width: 100%;
}

@media (max-width: 1280px) {

    .custom-file-input {
        margin-left: 0;
    }
}

@media (max-width: 768px) {
    .add_asset_btn--red {
        margin-top: 0;
    }

    .b-form-datepicker {
        margin-bottom: 20px;
    }
}

@media (max-width: 575px) {
    .add_asset_btn--red {
        margin-top: 30px;
    }
}
</style>

<style>
.form-add button.h-auto {
    opacity: 0;
}

.form-add .no-gutters {
    margin: 0;
}

.form-add .b-calendar-grid-help {
    display: none;
}

.form-add .b-calendar .form-control:focus,
.form-add .b-form-datepicker.form-control.focus,
.form-add .form-control.focus {
    box-shadow: none;
    border: 1px solid #ced4da6e;
}

.form-add .text-truncate {
    padding: 0;
}

.form-add .b-form-datepicker,
.form-add .b-form-timepicker {
    background-color: #EEEEEE;
    border-radius: 12px;
    padding: 2px 12px;
}

.form-add .text-muted {
    color: #B4B4B4 !important;
}

.form-add .button-list .dropdown-toggle {
    justify-content: flex-start;
    background-color: #EEEEEE;
    border-radius: 15px;
    padding: 12.5px 12px;
}

.add_asset .table {
    overflow: auto;
}

.add_asset table,
.add_asset tr,
.add_asset td {
    border: 1px solid #515151;
}
/* input:checked + label {
    color: green;
}
input:not(:checked) + label {
    color: red;
} */
</style>